<template>
  <v-dialog v-model="dialog" scrollable max-width="60%" persistent>
    <v-card>
      <v-card-title>
        <v-row class="ma-0 pa-0">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
          <v-col class="pt-0 pb-0 text-center" cols="12">
            <h1>Editar arquivo</h1>
            <span style="font-size:16px;font-weight:normal">{{anexo.arq_nome}}</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row wrap class="mx-0 my-5 pt-5" >
          <v-col cols="3" class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Código do erro:</span>
            <span style="font-size:16px;font-weight:normal">{{anexo.codigo_erro_tiss}}</span>
          </v-col>
          <v-col cols="9" class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Descrição do erro:</span>
            <span style="font-size:16px;font-weight:normal">{{anexo.descricao_erro_tiss}}</span>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col class="py-0" cols="12">
            <v-form ref="anexos_tipo">
              <v-row class="py-0">
                <v-col class="py-0" cols="4">
                  <label>Tipo de arquivo</label>
                  <v-select
                    v-model="anexo.tipo_anexo"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    :items="tiposEnvio"
                    item-text="tipo"
                    item-value="id"
                    outlined
                    :placeholder="'Selecione'"
                    :rules="formRules.required"
                    ></v-select>
                </v-col>
      <v-col class="py-0" cols="4" v-if="anexo_tiss">
        <label>Tipo de documento</label>
        <v-select
          v-model="anexo.tipo_documento"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          :items="tipoDocumentoTISS"
          item-text="tipo"
          item-value="id"
          outlined
          :placeholder="'Selecione'"
          :rules="formRules.required"
          ></v-select>
      </v-col>
      <v-col class="py-0" cols="4" v-if="anexo_tiss">
        <label>Formato de documento</label>
        <v-select
          v-model="anexo.formato_documento"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          :items="formatoDocumentoTISS"
          item-text="tipo"
          item-value="id"
          outlined
          :placeholder="'Selecione'"
          :rules="formRules.required"
          ></v-select>
      </v-col>
                
                <v-col class="py-0 " cols="12" v-if="anexo_tiss">
        <label>Observação</label>
        <v-textarea
          outlined
          no-resize
          v-model ="anexo.observacao"      
          :rules="[formRules.max500]"
        ></v-textarea>
      </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      
      </v-card-text>
    <v-card-actions>
      <v-col class="d-flex justify-end pb-2 px-5 mb-0" cols="12">
      <v-btn
          color="primary"
          max-width="100%"
          height="30px"
          small
          outlined
          @click="close()" 
          >Cancelar
          </v-btn>
      <v-spacer></v-spacer>
         <v-btn
          color="primary"
          max-width="100%"
          height="30px"
          small
          depressed
          @click="atualizarArquivo()" 
          >Salvar
          </v-btn>
      </v-col>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
  components: {
    
  },
  data() {
    return {
      anexo:{},
      tituloPorTipo: {
        lotes: "ao lote",
        guias: "à guia",
        itens: "ao item",
      },
      listaDeAnexos: [{ tipo: null, anexo: null, exte: '.pdf' }],
      formatoDocumentoTISS: [
        {id:null, tipo:"Selecione"},
        {id:"01", tipo:"JPG ou JPEG"},
        {id:"02", tipo:"PDF"},
        {id:"03", tipo:"PNG"},
        {id:"04", tipo:"TIFF"},
        {id:"05", tipo:"CADES - JPG ou JPEG"},
        {id:"06", tipo:"CADES PDF"},
        {id:"07", tipo:"CADES PNG"},
        {id:"08", tipo:"CADES TIFF"},
        {id:"09", tipo:"PADES"}
      ],
      tipoDocumentoTISS: [
        {id:null, tipo:"Selecione"},
        {id:"01", tipo:"Comprovante de elegibilidade"},
        {id:"02", tipo:"Laudo do profissional de saúde"},
        {id:"03", tipo:"Pedido do profissional de saúde"},
        {id:"04", tipo:"Relatório do profissional de saúde"},
        {id:"05", tipo:"Prescrição do profissional de saúde"},
        {id:"06", tipo:"Comprovante de comparecimento (assinatura)"},
        {id:"07", tipo:"Embalagem/rótulo de materiais e/ou medicamentos"},
        {id:"08", tipo:"Comprovante de entrega de medicamentos"},
        {id:"09", tipo:"Notas fiscais"},
        {id:"10", tipo:"Boletim anestésico"},
        {id:"11", tipo:"Selos hemoterápicos"},
        {id:"12", tipo:"Exames de imagem"},
        {id:"13", tipo:"Exames de análises clínicas"},
        {id:"14", tipo:"Termo de consentimento"},
        {id:"15", tipo:"Guia de cobrança de taxa"},
        {id:"16", tipo:"Autorização prévia"},
        {id:"17", tipo:"Relatório de Auditoria"}
      ],
      tiposEnvio: [
        {id: null, tipo: 'Selecione'},
        {id: 1, tipo: 'Materiais - Medicamentos'},
        {id: 2, tipo: 'Procedimentos'}
      ],
      formData: {
            id: null,
            anexo: null
      },
      resEnvio: true,
      parametrosAnexo: {
        extensoes: [".pdf", ".xlsx", ".png", ".jpg", ".gif", ".txt"],
        qtde_maxima: 5,
        tamanho_maximo: 5 * 1024,
        max_nome_arquivo: 50
      },
      anexo_tiss: false
    }
  },
  watch: {
    dialog() {
      this.anexo = {...this.itemSelecionado}
      this.resEnvio = true
      if(this.parametros && this.parametros.RG_ENVIO_ANEXO && this.parametros.RG_ANEXO_PARAM){
          this.parametrosAnexo = Object.assign(this.parametrosAnexo, JSON.parse(this.parametros.RG_ANEXO_PARAM))
          this.parametrosAnexo.extensoes = JSON.parse(this.parametrosAnexo.extensoes)
          this.parametrosAnexo.max_nome_arquivo == undefined ? this.parametrosAnexo.max_nome_arquivo = 50 : null    
      }
      if(this.parametros && this.parametros.RG_ANEXO_TISS) {
        this.anexo_tiss = this.parametros.RG_ANEXO_TISS
      }
    }
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules
    }),
  },
  mounted() {
  },
  
  methods: {
    ...mapActions({
      getDocument: "documents/getDocument"
    }),
    atualizarArquivo() {

      let payload = { grupo_economico: this.grupoEconomico, ...this.anexo };
      payload.operadora_ans_id = this.dadosPagamento.operadora_ans_id
      payload.prestador_id = this.dadosPagamento.prestador_id
      let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "UpdateAnexoRecurso",
              payload: payload,
            }
          ]
        };
        this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.updateItem({...this.anexo})
        let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: ()=>this.close(),
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    verificaRegras(){
      console.log('verificaRegras')
      let resTeste = []
      this.listaDeAnexos.forEach(item => {
        resTeste.push(this.parametrosAnexo.extensoes.filter(ele => ele.toLowerCase() == item.exte.toLowerCase()).length > 0 ? false : true)
        resTeste.push(item.anexo != null ? item.anexo.size / 1024 > this.parametrosAnexo.tamanho_maximo ? true : false : false)
        resTeste.push(item.anexo != null ? item.anexo.name.length > this.parametrosAnexo.max_nome_arquivo ? true : false : false)
        resTeste.push(item.anexo != null ? item.anexo.name.substring(0,item.anexo.name.lastIndexOf('.')).length > item.anexo.name.substring(0,item.anexo.name.lastIndexOf('.')).match(/[A-Za-z0-9._-\s]/gi).length ? true : false : false)
      })
      if(resTeste.indexOf(true) == -1){
        return false
      }
      return true
    },
    confirmEnviarArquivos(){
      if(this.$refs.anexos_tipo.validate()){
        this.enviarArquivos()
      } 
    }
  },
  props: {
    close: Function,
    dadosPagamento: Object,
    dialog: Boolean,
    grupoEconomico: Number,
    itemSelecionado: Object,
    parametros: Object,
    updateItem: Function
  },
};
</script>

<style>


</style>